import { Clock, AlertCircle, RotateCw, Trash2, FileText, Mic, Receipt } from "lucide-react";

const Preview = ({ d }) => {
  if (d.kind === "image" && d.preview) return <img src={d.preview} alt="Fotografia em envio" className="mb-1 max-h-60 rounded-md object-cover" />;
  if (d.kind === "audio") return <p className="mb-1 flex items-center gap-2 text-[15px]"><Mic className="h-5 w-5 text-zap-deep" /> Áudio</p>;
  if (d.file) {
    const Icon = d.kind === "receipt" ? Receipt : FileText;
    return <p className="mb-1 flex items-center gap-2 text-[15px]"><Icon className="h-5 w-5 text-zap-deep" /> <span className="truncate">{d.file.name}</span></p>;
  }
  return null;
};

export const Outbox = ({ items, onRetry, onDiscard }) => (
  <div data-testid="outbox">
    {items.map((it) => (
      <div key={it.localId} className="msg-enter flex justify-end px-3 sm:px-6">
        <div data-testid={`outbox-item-${it.status}`}
          className={`bubble-out relative my-1 max-w-[86%] rounded-lg rounded-tr-none px-3 pb-1.5 pt-2 text-[17px] leading-relaxed text-zap-ink sm:max-w-[68%] ${it.status === "failed" ? "bg-red-50 ring-1 ring-red-200" : "bg-zap-bubble/70"}`}>
          <Preview d={it.draft} />
          {it.draft.text && <p className="whitespace-pre-wrap break-words">{it.draft.text}</p>}
          {it.status === "sending" ? (
            <p data-testid="outbox-sending" className="mt-0.5 flex items-center justify-end gap-1 text-xs text-zap-ink/60"><Clock className="h-3.5 w-3.5" /> Enviando…</p>
          ) : (
            <div className="mt-1 space-y-1.5">
              <p data-testid="outbox-failed" className="flex items-center gap-1 text-sm font-semibold text-red-700"><AlertCircle className="h-4 w-4" /> Falha no envio{it.error ? `: ${it.error}` : ""}</p>
              <div className="flex gap-2">
                <button data-testid="outbox-retry" onClick={() => onRetry(it)} className="flex h-11 flex-1 items-center justify-center gap-1.5 rounded-md bg-zap-deep px-3 text-[15px] font-bold text-white"><RotateCw className="h-4 w-4" /> TENTAR NOVAMENTE</button>
                <button data-testid="outbox-discard" onClick={() => onDiscard(it)} aria-label="Descartar" className="flex h-11 w-11 items-center justify-center rounded-md border border-red-200 text-red-700"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
          )}
        </div>
      </div>
    ))}
  </div>
);
